<template>
	<div v-if="invite">
		<v-row>
			<v-col>
				<v-alert
						id="welcomeAlert"
						class="rounded-lg"
						color="info"
						outlined
						:style="{
						backgroundImage: 'url(/images/portals/welcome-alert-bg.jpg) !important',
						backgroundPosition: 'center center !important',
						backgroundSize: 'cover !important'
					}"
						text
				>
					<div>
						<v-row no-gutters :style="{ minHeight: `${welcomeBannerHeight}px` }">
							<v-col class="align-self-center pa-4" cols="12" lg="6" md="9" xl="6">
								<h2 class="font-weight-light mb-4 text-h2 text-md-h1 white--text">
									You're Invited
								</h2>
								<div
										class="white--text"
										:class="$vuetify.breakpoint.lgAndUp ? 'text-body-1' : 'text-body-2'"
								>
									You've been invited to take part in the Missouri Wines - Rewards
									Uncorked pass. Getting started is as easy as confirming your business
									info is correct.
								</div>
								<v-divider class="my-4" dark></v-divider>

								<h5 class="font-weight-light mb-4 mt-8 white--text">
									Other Invited Merchants
								</h5>

								<invite-avatars
										:avatarSize="$vuetify.breakpoint.smAndDown ? 36 : 48"
										border="white"
										dark
										:invite="invites[0]"
								></invite-avatars>

								<div
										class="my-4 white--text"
										:class="$vuetify.breakpoint.lgAndUp ? 'text-body-1' : 'text-body-2'"
								>
									Join the other {{ invitees.length }} merchants on the
									{{ invite.dealName }} Pass today! Confirm your details by clicking below
									and be on your way to success.
								</div>
								<v-divider class="my-4" dark></v-divider>
								<v-btn
										:block="$vuetify.breakpoint.smAndDown"
										class="mt-4"
										color="primary"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										rounded
										:x-large="$vuetify.breakpoint.lgAndUp"
								>
									<v-icon class="me-4">mdi-arrow-right-box</v-icon>
									Confirm Business Details
								</v-btn>
								<div>
									<v-btn
											:block="$vuetify.breakpoint.smAndDown"
											class="mt-4 white--text"
											color="transparent"
											depressed
											:large="$vuetify.breakpoint.mdAndUp"
											rounded
											:x-large="$vuetify.breakpoint.lgAndUp"
									>
										<v-icon class="me-4">mdi-checkbox-blank-outline</v-icon>
										View Invitation Details
									</v-btn>
								</div>
							</v-col>
						</v-row>
					</div>
				</v-alert>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: 'Welcome',
	props: {
		invites: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			welcomeBannerHeight: 0
		};
	},
	computed: {
		welcomeAlert() {
			return document.getElementById('welcomeAlert');
		},
		invite() {
			return this.invites.filter(invite => invite.status === 15)[0];
		},
		invitees() {
			if(!this.invite) return [];
			return this.invite.otherInvitees;
		}
	},
	methods: {
		onResize() {
			if(!this.welcomeAlert) return setTimeout(() => this.onResize(), 200);

			const { top } = this.welcomeAlert.getBoundingClientRect();
			const margin = this.$vuetify.breakpoint.xsOnly ? 50 : 64;
			const scroll = document.getElementById('page-scrolled').scrollTop;

			this.welcomeBannerHeight = this.$vuetify.breakpoint.height - top - margin - scroll;
		}
	},
	beforeDestroy() {
		if(typeof window === 'undefined') return;

		window.removeEventListener('resize', this.onResize, { passive: true });
	},
	mounted() {
		setTimeout(() => this.onResize(), 200);

		window.addEventListener('resize', this.onResize, { passive: true });
	}
};
</script>
